/**
 * Created by iamso on 15.11.2021
 */
const RuinsWindow = CleverappsWindow.extend({
    onWindowLoaded: function (ruins) {
        this.ruins = ruins;
        this.expeditionData = cleverapps.skins.getSlot("ruinsWindow");
        this.bundle = bundles[RuinsWindow.GetTargetBundleName()];

        this.unitIcons = [];
        this.unitAmounts = [];

        const styles = cleverapps.styles.RuinsWindow;

        this._super({
            title: Messages.get(this.getDictionaryKey("title")),
            name: "RuinsWindow",
            content: this.createContent(),
            noBackground: styles.noBackground,
            openSound: this.bundle.urls.open_sfx
        });

        this.unitsNode = new cc.Node();
        this.window.addChild(this.unitsNode);
        this.unitsNode.setLocalZOrder(1);
    },

    onPopUpAnimationFinished: function () {
        this._super();

        const place = (node) => {
            node.unitNodePosition = node.getPosition();
            node.originalScaleX = node.scaleX;
            node.originalScaleY = node.scaleY;
            node.replaceParentSamePlace(this.unitsNode, { keepScale: true });
        };

        this.unitIcons.forEach(place);
        this.unitAmounts.forEach(place);
    },

    onResize: function () {
        this._super();

        this.unitIcons.concat(this.unitAmounts).forEach((node) => {
            const worldPos = node.unitNode.convertToWorldSpace(node.unitNodePosition);
            node.setPosition(this.unitsNode.convertToNodeSpace(worldPos));

            const scale = cc.Base.AdjustScaleTo(node.unitNode, this.unitsNode);
            node.setScaleX(node.originalScaleX * scale.x);
            node.setScaleY(node.originalScaleY * scale.y);
        });
    },

    getPerson: function () {
        const expeditionData = cleverapps.skins.getSlot("ruinsWindow");
        return expeditionData && expeditionData.person || cleverapps.persons.choose("miner", "dwarf");
    },

    getDictionaryKey: function (key) {
        if (this.expeditionData && this.expeditionData.dictionaryKey) {
            return this.expeditionData.dictionaryKey + key;
        }
        return `RuinsWindow.${key}`;
    },

    createContent: function () {
        const cta = cleverapps.UI.generateOnlyText(Messages.get(this.getDictionaryKey("cta")), cleverapps.styles.FONTS.RUINS_CTA);

        return new cleverapps.Layout([cta, this.createTimer(), this.createTiers()], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.RuinsWindow.ctaMargin
        });
    },

    createTimer: function () {
        const styles = cleverapps.styles.RuinsWindow.timer;

        return new cleverapps.CountDownView(new cleverapps.CountDown(this.ruins.getTimeLeft()), {
            font: cleverapps.styles.FONTS.RUINS_TIMER,
            background: {
                frame: bundles.timer.frames.timer_bg_png,
                width: styles.width,
                height: styles.height
            },
            icon: bundles.timer.frames.timer_png,
            timerPosition: styles.position
        });
    },

    createTiers: function () {
        const cheap = this.createTier("cheap");
        const costly = this.createTier("costly");

        return new cleverapps.Layout([cheap, costly], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.RuinsWindow.platesMargin
        });
    },

    createTier: function (tierName) {
        const styles = cleverapps.styles.RuinsWindow.plate;

        const plate = new cc.Node();
        plate.setAnchorPoint(0.5, 0.5);
        plate.setContentSize2(styles);

        const bg = cleverapps.UI.createScale9Sprite(tierName === "cheap" ? this.bundle.frames.tier1_bg : this.bundle.frames.tier2_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize(plate.getContentSize());
        plate.addChild(bg);
        bg.setAlignment(plate.width / 2, plate.height / 2);

        if (this.bundle.frames.tier_title) {
            const titleBg = cleverapps.UI.createScale9Sprite(this.bundle.frames.tier_title, cleverapps.UI.Scale9Rect.TwoPixelXY);
            titleBg.setContentSize(styles.titleBg);
            plate.addChild(titleBg);
            titleBg.setAlignment(styles.titleBg);
        }

        const title = cleverapps.UI.generateOnlyText(Messages.get(this.getDictionaryKey(`plateName.${tierName}`)), cleverapps.styles.FONTS.RUINS_PLATE_TITLE);
        title.fitTo(styles.title.width);
        plate.addChild(title);
        title.setAlignment(styles.title);

        const rewardsNode = this.createPlateRewards(tierName);
        plate.addChild(rewardsNode);
        rewardsNode.setAlignment(styles.units);

        const button = this.button = this.createPlateButton(tierName);
        plate.addChild(button);
        button.setAlignment(styles.button);

        const tool = new cc.Node();
        tool.addChild(new cc.Sprite(tierName === "cheap" ? this.bundle.frames.tier1_tool : this.bundle.frames.tier2_tool));
        cleverapps.UI.setDimensions(tool, {
            height: styles.toolHeight
        });

        return new cleverapps.Layout([tool, plate], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.toolMargin
        });
    },

    createPlateRewards: function (tierName) {
        const rewards = this.ruins.getRelevantTier(tierName).rewards;
        const rows = [], inRow = 2;
        while (rewards.length > rows.length * inRow) {
            const rowItems = rewards.slice(rows.length * inRow, rows.length * inRow + 2).map((unit) => this.createUnitReward(unit));

            rows.push(new cleverapps.Layout(rowItems, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: cleverapps.styles.RuinsWindow.plate.units.marginX
            }));
        }

        return new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.RuinsWindow.plate.units.marginY
        });
    },

    createUnitReward: function (unit) {
        const styles = cleverapps.styles.RuinsWindow.unit;

        const unitNode = new cc.Node();
        unitNode.setAnchorPoint(0.5, 0.5);
        unitNode.setContentSize2(styles);

        const icon = UnitView.getUnitImage(unit);
        cleverapps.UI.fitToBox(icon, styles.icon);
        unitNode.addChild(icon);
        icon.setAlignment(styles.icon);
        icon.unitNode = unitNode;
        this.unitIcons.push(icon);

        const amount = cleverapps.UI.generateImageText(`x${unit.amount}`, cleverapps.styles.FONTS.RUINS_UNITREWARD_AMOUNT);
        unitNode.addChild(amount);
        amount.setAlignment(styles.amount);
        amount.unitNode = unitNode;
        this.unitAmounts.push(amount);

        return unitNode;
    },

    createPlateButton: function (tierName) {
        const tierData = this.ruins.getRelevantTier(tierName);

        const styles = cleverapps.styles.RuinsWindow;

        return new cleverapps.UI.Button({
            type: tierData.soft ? cleverapps.styles.UI.Button.Images.button_green : cleverapps.styles.UI.Button.Images.button_blue,
            text: tierData.soft ? `@@${tierData.soft}` : `$$${tierData.hard}`,
            width: styles.plate.button.width,
            height: styles.plate.button.height,
            onClicked: () => {
                if (this.ruins.buy(tierName)) {
                    this.close();
                }
            }
        });
    },

    listBundles: function () {
        return [RuinsWindow.GetTargetBundleName()];
    }
});

RuinsWindow.GetTargetBundleName = function () {
    const expeditionData = cleverapps.skins.getSlot("ruinsWindow");
    if (expeditionData && bundles[expeditionData.bundle]) {
        return expeditionData.bundle;
    }
    return "ruinswindow";
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RUINS_CTA: {
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    RUINS_PLATE_TITLE: {
        size: 55,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    RUINS_UNITREWARD_AMOUNT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    RUINS_TIMER: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.RuinsWindow = {
    platesMargin: 20,
    ctaMargin: 10,

    plate: {
        width: 380,
        height: 470,
        toolMargin: 20,
        toolHeight: 180,

        units: {
            marginX: 15,
            marginY: 5,
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -140 }
        },

        title: {
            width: 320,
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -25 }
        },

        button: {
            width: 250,
            height: 100,
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 40 }
        }
    },

    unit: {
        width: 160,
        height: 85,

        icon: {
            width: 100,
            height: 85,
            maxScale: 1.3,
            x: { align: "center", dx: -40 },
            y: { align: "center", dy: 0 }
        },

        amount: {
            x: { align: "left", dx: 85 },
            y: { align: "center", dy: 5 }
        }
    },

    timer: {
        width: 275,
        height: 55
    },

    window: {}
};
